import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useConsent } from "@/lib/consent";

export const ADSENSE_CLIENT = "ca-pub-8254641846300364";
const CLIENT = ADSENSE_CLIENT;
export const NO_AD_PATHS = ["/privacy", "/cookies", "/terms", "/support", "/about", "/why-free", "/unsubscribe", "/login", "/shared", "/admin", "/contact", "/editorial-policy"];

export const adsAllowedOn = (path) => !NO_AD_PATHS.some((p) => path === p || path.startsWith(`${p}/`));

export function AdSenseLoader() {
  const { pathname } = useLocation();
  const consent = useConsent();
  const allowed = adsAllowedOn(pathname);
  const personalized = consent === "accepted";
  useEffect(() => {
    document.body.classList.toggle("no-ads", !allowed);
    document.body.dataset.ads = allowed ? (personalized ? "on" : "non-personalized") : "off";
    window.adsbygoogle = window.adsbygoogle || [];
    window.adsbygoogle.requestNonPersonalizedAds = personalized ? 0 : 1;
    window.adsbygoogle.pauseAdRequests = allowed ? 0 : 1;
    if (allowed && !document.getElementById("adsense-script")) {
      const s = document.createElement("script");
      s.id = "adsense-script";
      s.async = true;
      s.crossOrigin = "anonymous";
      s.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${CLIENT}`;
      document.head.appendChild(s);
    }
  }, [allowed, personalized]);
  return null;
}
